import {
    DELETE_TEMPLATE_SECTION,
    FETCHED_TEMPLATE,
    FETCHED_TEMPLATES,
    MOVE_TEMPLATE_SECTION,
    NEW_TEMPLATE_SECTION,
    SAVED_TEMPLATE,
    UPDATE_NEW_PLACEHOLDER,
    OPEN_PLACEHOLDER_EDIT_POPUP,
    CLOSE_PLACEHOLDER_EDIT_POPUP,
    DONE_EDIT_PLACEHOLDER_POPUP,
    FETCHED_EDITS_HISTORY,
    ENABLE_SECTION,
    DISABLE_SECTION
} from './types';
import update from 'immutability-helper/index';
import {FETCHED_ELEMENTS} from './types';
import shortid from 'shortid';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';

const INITIAL_STATE = {
    all: [],
    template: {},
    elements: [],
    isDirty: false,
    newPlaceholder: '',
    toEditSectionUniqueId: '',
    editsHistory: [],
    editPlaceholderPopup: {
        open: false,
    },
    pageTypeId: ''
};

export default function (state = INITIAL_STATE, action) {
    let toEditSection;
    let toEditSectionPosition;
    let updatedSection;
    let updatedTemplate;

    switch (action.type) {

        case FETCHED_TEMPLATES:

            return update(state, {
                all: {$set: action.payload}
            });

        case FETCHED_TEMPLATE:

            return update(state, {
                isDirty: {$set: false},
                template: {$set: action.payload},
                pageTypeId: {$set: action.payload.page_type_id}
            });

        case FETCHED_ELEMENTS:

            return update(state, {
                elements: {$set: action.payload.elements}
            });

        case MOVE_TEMPLATE_SECTION:

            let templates = state.template.data.filter(item => item.deleted !== true);
            
            updatedTemplate = update(templates, {
                $splice: [
                    [action.payload.dragIndex, 1],
                    [action.payload.hoverIndex, 0, action.payload.dragCard]
                ]
            });

            return update(state, {
                isDirty: {$set: true},
                template: {
                    data: {
                        $set: [ ...new Set(updatedTemplate)]
                    }
                }
            });

        case DELETE_TEMPLATE_SECTION:

            toEditSectionPosition = _findIndex(
                state.template.data, {uniqueId: action.payload.sectionId}
            );

            toEditSection = _find(
                state.template.data, {uniqueId: action.payload.sectionId}
            );

            updatedSection = update(toEditSection, {
                $merge: {
                    deleted: true
                }
            });

            return update(state, {
                isDirty: {$set: true},
                template: {
                    data: {[toEditSectionPosition]: {$set: updatedSection}}
                }
            });

        case SAVED_TEMPLATE:

            return update(state, {
                isDirty: {$set: false}
            });

        case NEW_TEMPLATE_SECTION:

            return update(state, {
                isDirty: {$set: true},
                template: {
                    data: {
                        $splice: [
                            [action.payload.dropWhere + 1, 0, {
                                id: null,
                                uniqueId: shortid.generate(),
                                type_id: action.payload.sectionTypeId,
                                section_type: action.payload.sectionType,
                                section_text_id: 0,
                                placeholder_name: 'placeholder name here ...',
                                new: true,
                                touched: true,
                                deleted: false,
                            }]
                        ]
                    }
                }
            });
            
        //START PLACEHOLDER NAME
        case UPDATE_NEW_PLACEHOLDER:

            return update(state, {
                newPlaceholder: {$set : action.payload}
            });

        case OPEN_PLACEHOLDER_EDIT_POPUP:

            return update(state, {
                newPlaceholder: {$set : action.payload.placeholder },
                toEditSectionUniqueId: {$set : action.payload.sectionUniqueId },
                editPlaceholderPopup: {
                    open: {$set: true }
                }
            });

        case DONE_EDIT_PLACEHOLDER_POPUP:

            toEditSectionPosition = _findIndex(
                state.template.data, {uniqueId: state.toEditSectionUniqueId}
            );

            toEditSection = _find(
                state.template.data, {uniqueId: state.toEditSectionUniqueId}
            );

            updatedSection = update(toEditSection, {
                $merge: {
                    placeholder_name: action.payload
                }
            });

            return update(state, {
                isDirty: {$set: true},
                editPlaceholderPopup: {
                    open: {$set: false}
                },
                template: {
                    data: {[toEditSectionPosition]: {$set: updatedSection}}
                }
            });

        case CLOSE_PLACEHOLDER_EDIT_POPUP:

            return update(state, {
                editPlaceholderPopup: {
                    open: {$set: false }
                }
            });
        
        //End Placeholder Name
        
        case FETCHED_EDITS_HISTORY:

            return update(state, {
                editsHistory: {$set: action.payload}
            });

        case ENABLE_SECTION:
        
            toEditSectionPosition = _findIndex(
                state.template.data, {uniqueId: action.payload.sectionId}
            );

            toEditSection = _find(
                state.template.data, {uniqueId: action.payload.sectionId}
            );

            updatedSection = update(toEditSection, {
                $merge: {
                    is_visible: 1
                }
            });

            return update(state, {
                isDirty: {$set: true},
                template: {
                    data: {[toEditSectionPosition]: {$set: updatedSection}}
                }
            });

        case DISABLE_SECTION:

            toEditSectionPosition = _findIndex(
                state.template.data, {uniqueId: action.payload.sectionId}
            );

            toEditSection = _find(
                state.template.data, {uniqueId: action.payload.sectionId}
            );

            updatedSection = update(toEditSection, {
                $merge: {
                    is_visible: 0
                }
            });

            return update(state, {
                isDirty: {$set: true},
                template: {
                    data: {[toEditSectionPosition]: {$set: updatedSection}}
                }
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/templates/reducer.js